export const StoreRoutes = [
  // Select an Org
  { path: '', lazy: () => import('./pages/store') },
  {
    path: ':oid',
    lazy: () => import('./pages/store._$oid'),
    children: [
      // Overview
      { path: '', lazy: () => import('./pages/store.$oid') },
      // Calendar
      { path: 'calendar', lazy: () => import('./pages/store.$oid.calendar') },
      // Guest checkout confirmation (fetch-free; not event/membership-specific)
      { path: 'purchase/success', lazy: () => import('./pages/store.$oid.purchase.success') },
      // Profile
      { path: 'profile', lazy: () => import('./pages/store.$oid.profile') },
      { path: 'profile/unsubscribe/:email', lazy: () => import('./pages/store.$oid.unsubscribe.$email') },
      { path: 'profile/checkin', lazy: () => import('./pages/store.$oid.profile.membership.checkin') },
      { path: 'profile/tickets', lazy: () => import('./pages/store.$oid.profile.tickets') },
      { path: 'profile/fix', lazy: () => import('./pages/store.$oid.profile.fix') },
      { path: 'profile/tickets/today', lazy: () => import('./pages/store.$oid.profile.tickets.today') },
      { path: 'profile/tickets/:pid', lazy: () => import('./pages/store.$oid.profile.tickets.$pid') },
      { path: 'profile/festivals/:fid', lazy: () => import('./pages/store.$oid.profile.festivals.$fid') },
      { path: 'profile/payment-error', lazy: () => import('./pages/store.$oid.profile.payment-error') },
      { path: 'profile/purchases/:purchaseId', lazy: () => import('./pages/store.$oid.profile.purchases.$purchaseId') },
      { path: 'profile/purchases/:purchaseId/payment-return', lazy: () => import('./pages/store.$oid.profile.purchases.$purchaseId.payment-return') },
      // Events
      { path: 'events', lazy: () => import('./pages/store.$oid.events') },
      { path: 'events/:pid',
        lazy: () => import('./pages/store.$oid.events._$pid'),
        children: [
          { path: '', lazy: () => import('./pages/store.$oid.events.$pid') },
          { path: 'purchase', lazy: () => import('./pages/store.$oid.events.$pid.purchase') },
          { path: 'wait-listed-purchase', lazy: () => import('./pages/store.$oid.events.$pid.wait-listed-purchase') },
          { path: 'purchase/success', lazy: () => import('./pages/store.$oid.events.$pid.purchase.success') },
        ],
      },
      // Festivals
      { path: 'festivals/:pid', lazy: () => import('./pages/store.$oid.festivals.$pid') },
      { path: 'festivals/:pid/purchase', lazy: () => import('./pages/store.$oid.festivals.$pid.purchase') },
      // Memberships
      { path: 'memberships', lazy: () => import('./pages/store.$oid.memberships') },
      { path: 'memberships/:mid/purchase', lazy: () => import('./pages/store.$oid.memberships.$mid.purchase') },
      { path: 'memberships/purchase/success', lazy: () => import('./pages/store.$oid.memberships.purchase.success') },
      // Donate
      { path: 'donate', lazy: () => import('./pages/store.$oid.donate') },
      { path: 'donate/success', lazy: () => import('./pages/store.$oid.donate.success') },
      // Contests
      { path: 'contests/:pid/judge/:userId', lazy: () => import('./pages/store.$oid.contests.$pid.judge.$userId')}
    ],
  },
]
